import React, { useState } from 'react';
import styles from '../Productos.module.scss';

interface DetailGalleryProps {
  imagenes: string[];
  nombre: string;
}

export const DetailGallery: React.FC<DetailGalleryProps> = ({ imagenes, nombre }) => {
  const [current, setCurrent] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!zoomed) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPos({ x, y });
  };

  if (!imagenes.length) {
    return <div className={styles.productos__noImage}>Sin imagen</div>;
  }

  return (
    <div className={styles.gallery}>
      <div
        className={`${styles.gallery__main} ${zoomed ? styles['gallery__main--zoomed'] : ''}`}
        onClick={() => setZoomed(z => !z)}
        onMouseMove={handleMouseMove}
        onMouseLeave={() => setZoomed(false)}
        title={zoomed ? 'Click para salir del zoom' : 'Click para hacer zoom'}
      >
        <img
          src={imagenes[current]}
          alt={nombre}
          className={styles.gallery__img}
          style={zoomed ? {
            transformOrigin: `${zoomPos.x}% ${zoomPos.y}%`,
            transform: 'scale(2.2)',
          } : {}}
        />
      </div>

      {imagenes.length > 1 && (
        <div className={styles.gallery__thumbs}>
          {imagenes.map((img, i) => (
            <div
              key={i}
              className={`${styles.gallery__thumb} ${i === current ? styles['gallery__thumb--active'] : ''}`}
              onClick={() => setCurrent(i)}
            >
              <img src={img} alt={`${nombre} ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};